// extracted by mini-css-extract-plugin
module.exports = {"shopifyInstallCompleteWrapper":"ShopifyInstallComplete_shopifyInstallCompleteWrapper__22h4G"};